if (!customElements.get("anchor-nav")) {
  customElements.define(
    "anchor-nav",
    class AnchorNav extends HTMLElement {
      constructor() {
        super();

        this.intersectionObserver = null;
        this.tabMode = this.dataset.tabMode === "true";

        this.getAnchors();
        if (this.anchors.length <= 0) return;

        this.setAnchorActive(this.anchors[0]["element"]);

        if (this.tabMode) {
          this.initTabMode();
        } else {
          this.boundOnClick = this.onClickHandler.bind(this);
          this.addEventListener("click", this.boundOnClick);

          if (document.readyState === "complete") {
            this.initObserver();
          } else {
            this.boundOnLoad = () => this.initObserver();
            window.addEventListener("load", this.boundOnLoad);
          }
        }
      }

      // ── Tab模式初始化 ──
      initTabMode() {
        // 页面加载时只显示第一个Tab的内容
        this.showPanelsForAnchor(this.anchors[0]["element"]);

        this.boundOnClick = this.onTabClickHandler.bind(this);
        this.addEventListener("click", this.boundOnClick);
      }

      onTabClickHandler(event) {
        const anchorItem = event.target.closest(".anchor-item");
        if (!anchorItem) return;
        event.preventDefault();

        this.setAnchorActive(anchorItem);
        this.showPanelsForAnchor(anchorItem);

        // 滚动到导航栏顶部
        const navSection = this.closest(".product-anchor-navigation-section");
        if (navSection) {
          const offset = navSection.getBoundingClientRect().top + window.scrollY - 20;
          window.scrollTo({ top: offset, behavior: "smooth" });
        }
      }

      showPanelsForAnchor(anchorItem) {
        // 获取当前Tab要显示的panel IDs
        const panelIds = (anchorItem.dataset.tabPanels || "").split(",").map(s => s.trim()).filter(Boolean);

        // 获取所有被任意Tab管理的panel IDs
        const allPanelIds = new Set();
        this.anchors.forEach(anchor => {
          const ids = (anchor.element.dataset.tabPanels || "").split(",").map(s => s.trim()).filter(Boolean);
          ids.forEach(id => allPanelIds.add(id));
        });

        // 隐藏所有managed panels
        allPanelIds.forEach(id => {
          const el = document.getElementById(id);
          if (el) el.style.display = "none";
        });

        // 显示当前Tab的panels
        panelIds.forEach(id => {
          const el = document.getElementById(id);
          if (el) el.style.display = "";
        });
      }

      // ── 原有锚点模式 ──
      onClickHandler(event) {
        const anchorItem = event.target.closest(".anchor-item");
        if (!anchorItem) return;
        event.preventDefault();

        const anchor = this.anchors.find(anchor => anchor.element === anchorItem);
        if (anchor?.target) {
          const anchorOffset = window.innerHeight * 0.3;
          webvista.scrollToElementWithOffset(anchor.target, anchorOffset);
        }
      }

      getAnchors() {
        this.anchors = Array.from(this.querySelectorAll(".anchor-item"))
          .map((item) => {
            const targetId = item.dataset.targetId;
            return {
              element: item,
              target: targetId ? document.getElementById(targetId) : null,
            };
          })
          .filter((anchor) => this.tabMode || anchor.target !== null);
      }

      initObserver() {
        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
        }

        const options = webvista.inIframe()
          ? { root: null, threshold: 0.3 }
          : { root: null, rootMargin: "-40% 0px" };

        this.intersectionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const activeAnchor = this.anchors.find(
                (anchor) => anchor.target === entry.target
              );
              if (activeAnchor) {
                this.setAnchorActive(activeAnchor.element);
              }
            }
          });
        }, options);

        this.anchors.forEach((anchor) => {
          this.intersectionObserver.observe(anchor.target);
        });
      }

      disconnectedCallback() {
        if (this.intersectionObserver) this.intersectionObserver.disconnect();
        if (this.boundOnClick) this.removeEventListener("click", this.boundOnClick);
        if (this.boundOnLoad) window.removeEventListener("load", this.boundOnLoad);
      }

      setAnchorActive(item) {
        if (!item) return;
        this.querySelector(".active")?.classList.remove("active");
        item.classList.add("active");
        this.setLinePosition(item);
        this.dispatchEvent(
          new CustomEvent("item-active", {
            bubbles: true,
            detail: { element: item },
          })
        );
      }

      setLinePosition(item) {
        if (!item) return;
        const wrapperRect = this.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const scrollLeft = this.scrollLeft || 0;
        const left = itemRect.left - wrapperRect.left + scrollLeft;
        const right = wrapperRect.right - itemRect.right - scrollLeft;
        this.style.setProperty("--item-left", `${left}px`);
        this.style.setProperty("--item-right", `${right}px`);
      }
    }
  );
}
